import {create} from 'zustand';

export const useAuth = create(() => ({
    isProcessing: true,
    access_token: '',
    refresh_token: '',
    permission: {},
    isAuth: false,
    isAuthorized: false,
    isAnonymus: false,
    authError: ''
  }));